/**
 * Store locator dropdown interactions (header).
 * Extracted from shopify.min.js to reduce document-level click work and improve INP.
 */
(function () {
  'use strict';

  var LOCATIONS_CACHE_KEY = 'curacao_store_locations_v1';
  var LOCATIONS_CACHE_TTL_MS = 10 * 60 * 1000; // 10 minutes
  var LOCATIONS_API = '/apps/gw/store/locations';
  var DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function getCookieSafe(name) {
    if (typeof window.getCookie === 'function') {
      return window.getCookie(name);
    }
    return null;
  }

  function setCookieSafe(name, value, days) {
    if (typeof window.setCookie === 'function') {
      window.setCookie(name, value, days);
    }
  }

  function ensureOverlay() {
    var overlay = document.querySelector('.store-locator-overlay');
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'store-locator-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);
    overlay.addEventListener('click', closePanel);
    return overlay;
  }

  function openPanel() {
    var content = document.querySelector('.store_locations_content');
    if (!content) return;
    var overlay = ensureOverlay();
    content.classList.add('active');
    document.body.classList.add('body_fix', 'store-locator-open');
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
  }

  function closePanel() {
    var content = document.querySelector('.store_locations_content');
    var overlay = document.querySelector('.store-locator-overlay');
    if (overlay) {
      overlay.classList.remove('is-visible');
    }
    // Two-frame close: fade overlay first, then drop heavy classes.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (content) content.classList.remove('active');
        document.body.classList.remove('body_fix', 'store-locator-open');
        if (overlay) overlay.setAttribute('aria-hidden', 'true');
      });
    });
  }

  function bindCloseButtons() {
    document.querySelectorAll('.store_locations_content .store_inner .close').forEach(function (el) {
      if (el.dataset.storeLocatorCloseBound === '1') return;
      el.dataset.storeLocatorCloseBound = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closePanel();
      });
    });
  }

  function readLocationsCache() {
    try {
      var raw = sessionStorage.getItem(LOCATIONS_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.expiresAt || Date.now() > parsed.expiresAt) {
        sessionStorage.removeItem(LOCATIONS_CACHE_KEY);
        return null;
      }
      return parsed.data || null;
    } catch (e) {
      return null;
    }
  }

  function writeLocationsCache(data) {
    try {
      sessionStorage.setItem(LOCATIONS_CACHE_KEY, JSON.stringify({
        expiresAt: Date.now() + LOCATIONS_CACHE_TTL_MS,
        data: data
      }));
    } catch (e) {
      // ignore quota / private mode
    }
  }

  function fetchLocations() {
    var cached = readLocationsCache();
    if (cached) {
      return Promise.resolve(cached);
    }
    return fetch(LOCATIONS_API)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP error! Status: ' + response.status);
        }
        return response.json();
      })
      .then(function (response) {
        var nodes = response && response.data && response.data.locations
          ? response.data.locations.nodes
          : null;
        if (nodes) writeLocationsCache(nodes);
        return nodes;
      });
  }

  function mapLocations(nodes) {
    return nodes.map(function (location) {
      return {
        id: location.id,
        name: location.name,
        address1: location.address.address1,
        address2: location.address.address2,
        city: location.address.city,
        country: location.address.country,
        latitude: location.address.latitude,
        longitude: location.address.longitude,
        province: location.address.province,
        provincecode: location.address.provinceCode,
        zip: location.address.zip,
        metafields: location.metafields.nodes,
        distance: null,
        distanceText: null,
        durationText: null
      };
    });
  }

  function buildLocationListHtml(locationsData, selectedStore) {
    var dayName = DAYS_OF_WEEK[new Date().getDay()];
    var fragment = document.createDocumentFragment();
    var wrap = document.createElement('div');

    for (var i = 0; i < locationsData.length; i++) {
      var location = locationsData[i];
      var storehours = location.metafields.filter(function (node) { return node.key == 'custom.hours'; });
      var pickupIdNodes = location.metafields.filter(function (node) { return node.key == 'custom.pickup_id'; });
      var pickupStoreNodes = location.metafields.filter(function (node) { return node.key == 'custom.pickup_instore'; });
      var pickup_id = (pickupIdNodes && pickupIdNodes.length > 0) ? pickupIdNodes[0].value : 'null';
      var pickup_store = (pickupStoreNodes && pickupStoreNodes.length > 0) ? pickupStoreNodes[0].value : 'null';

      if (pickup_store === 'null' || pickup_store === 'false') continue;

      var isActive = selectedStore != '' && selectedStore == location.name;
      var li = '<li class="location' + (isActive ? ' active' : '') + '" data-zip="' + location.zip + '" data-pickupid="' + pickup_id + '" data-pickupstore="' + pickup_store + '">';
      li += '<h3 class="title"><span>' + location.name + '</span><br>' + location.address1 + '<br>' + location.zip + '</h3>';
      li += '<div class="store_info">';
      li += '<a href="javascript:;" class="button store_name" data-province="' + location.provincecode + '" data-storename="' + location.name + '" data-zip="' + location.zip + '" data-lat="' + location.latitude + '" data-long="' + location.longitude + '">Make it my store</a>';
      li += '<a href="javascript:;" class="button store_name disabled" data-storename="' + location.name + '" data-zip="' + location.zip + '" data-lat="' + location.latitude + '" data-long="' + location.longitude + '">Selected</a>';
      li += '<div class="store-details detail show">Store details</div><div class="store-details all_details">All store info</div></div>';
      li += '<div class="all_store_info hide"><div class="store_info"><h4>Hours:</h4>';
      if (storehours != null && storehours.length > 0) {
        li += '<div class="schedule">';
        var schedule = storehours[0].value.split(',');
        for (var j = 0; j < schedule.length; j++) {
          var day = schedule[j].split(':')[0].trim();
          if (dayName == day) {
            li += '<span class="day active" data-day="' + day + '">' + schedule[j] + '</span>';
          } else {
            li += '<span class="day" data-day="' + day + '">' + schedule[j] + '</span>';
          }
        }
      } else {
        li += '<span class="day">COMING SOON</span>';
      }
      li += '</div></div><div class="close_sore_info">Close Store details</div></div></li>';
      wrap.insertAdjacentHTML('beforeend', li);
    }

    while (wrap.firstChild) {
      fragment.appendChild(wrap.firstChild);
    }
    return fragment;
  }

  function updateSelectedStoreName(locationsData) {
    var nameEl = document.querySelector('.storelocatore-dropdown_container .selected-store-nanme');
    if (!nameEl || !locationsData.length) return;
    var cookieName = getCookieSafe('store_location_name');
    if (cookieName) {
      nameEl.innerHTML = cookieName;
    } else {
      nameEl.innerHTML = locationsData[0].name;
    }
  }

  function handleLookup(btn, zip) {
    var selectedStore = getCookieSafe('store_location_name') || '';
    var errorEl = document.querySelector('.current_location_search_form .location_form .error');

    requestAnimationFrame(function () {
      btn.classList.add('active');
    });

    fetchLocations()
      .then(function (nodes) {
        if (!nodes) throw new Error('No locations');
        var locationsData = mapLocations(nodes);

        var availabilityPromise = Promise.resolve(null);
        if (typeof window.storeAvailabilityService !== 'undefined'
            && typeof window.storeAvailabilityService.getAvailability === 'function') {
          availabilityPromise = window.storeAvailabilityService.getAvailability({
            zipcode: zip,
            items: [{
              itemId: 'NOT_PROVIDED',
              sku: 'NOT_PROVIDED',
              isSet: false
            }]
          }).then(function (res) {
            return res && res.list && res.list[0] ? res.list[0].STORES : null;
          }).catch(function (e) {
            console.error(e);
            return null;
          });
        }

        return availabilityPromise.then(function (storeLocations) {
          if (Array.isArray(storeLocations) && storeLocations.length) {
            locationsData.forEach(function (locationData) {
              var pickupIdNode = locationData.metafields.find(function (node) {
                return node.key === 'custom.pickup_id';
              });
              var pickupId = pickupIdNode ? pickupIdNode.value : null;
              var pickupStoreLocationInfo = storeLocations.find(function (storeLocation) {
                return storeLocation.storeCode === pickupId;
              });
              if (!pickupStoreLocationInfo) return;
              var miles = pickupStoreLocationInfo.distance || null;
              locationData.distance = miles;
              locationData.distanceText = miles ? miles + ' mile' : '';
              locationData.durationText = null;
            });
            if (errorEl) errorEl.innerHTML = '';
          } else {
            if (errorEl) errorEl.innerHTML = 'Zip code invalid. Please enter a new zip code.';
            btn.classList.remove('active');
          }

          locationsData.sort(function (a, b) {
            return a.distance - b.distance;
          });

          updateSelectedStoreName(locationsData);

          var list = document.querySelector('.store_locations_content .locations');
          if (list) {
            list.innerHTML = '';
            list.appendChild(buildLocationListHtml(locationsData, selectedStore));
          }
          btn.classList.remove('active');
        });
      })
      .catch(function (error) {
        btn.classList.remove('active');
        console.error(error);
      });
  }

  function handleSelectStore(storeBtn) {
    var storeLocationName = storeBtn.getAttribute('data-storename');
    var storeProvince = storeBtn.getAttribute('data-province');
    var lat = storeBtn.getAttribute('data-lat');
    var long = storeBtn.getAttribute('data-long');
    var zip = storeBtn.getAttribute('data-zip');

    setCookieSafe('store_location_name', storeLocationName, 365);
    setCookieSafe('store_location_latitude', lat, 365);
    setCookieSafe('store_location_longitude', long, 365);
    setCookieSafe('store_location_zip', zip, 365);
    setCookieSafe('store_province', storeProvince, 365);

    var nameEl = document.querySelector('.storelocatore-dropdown_container .selected-store-nanme');
    if (nameEl) nameEl.innerHTML = getCookieSafe('store_location_name');

    document.querySelectorAll('.store_locations_content .locations .location').forEach(function (element) {
      element.classList.remove('active');
    });
    var locationEl = storeBtn.closest('.location');
    if (locationEl) locationEl.classList.add('active');

    var elementCode = document.querySelector('.group-button-buyitnow .live-zip-code');
    var cookieZip = getCookieSafe('store_location_zip');
    if (elementCode && cookieZip != null) {
      if (document.body.classList.contains('template-product')) {
        var buyItNowZip = document.querySelector('.group-button-buyitnow .live-zip-code');
        var zipInput = document.querySelector('#product-store-default-zip-popup .product-store-default-zip-code');
        if (buyItNowZip) buyItNowZip.innerHTML = cookieZip;
        if (zipInput) zipInput.value = cookieZip;
      }
      var liveZip = document.querySelector('.live-zip-code');
      if (liveZip) liveZip.innerHTML = cookieZip;
    }

    if (document.body.classList.contains('template-cart')) {
      location.reload();
    }
  }

  function onDocumentClick(e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;

    // Open panel
    if (target.closest('.storelocatore-dropdown, .selected-store-nanme, .change-location-header')) {
      // Avoid opening when clicking close or inside the panel content actions unrelated to trigger
      if (target.closest('.store_locations_content .close')) return;
      if (target.closest('.store_locations_content .locations')) return;
      if (target.closest('.search_loc') || target.closest('.current_loc_js')) return;
      openPanel();
      return;
    }

    // Lookup
    var submitBtn = target.closest('.store_locations_content .search_loc .search_submit');
    if (submitBtn) {
      var input = document.querySelector('.search_location_input');
      var zip = input ? input.value : '';
      if (/^\d+$/.test(zip)) {
        handleLookup(submitBtn, zip);
      }
      return;
    }

    // Make it my store (ignore disabled selected button)
    var storeNameBtn = target.closest('.store_locations_content .locations .location .store_info a.button.store_name:not(.disabled)');
    if (storeNameBtn) {
      handleSelectStore(storeNameBtn);
      return;
    }

    // Expand store details
    var detailsShow = target.closest('.store_locations_content .locations .location .store_info .store-details.detail.show');
    if (detailsShow) {
      detailsShow.classList.remove('show');
      var storeInfo = detailsShow.closest('.store_info');
      if (storeInfo) {
        var allDetails = storeInfo.querySelector('.all_details');
        if (allDetails) allDetails.classList.add('show');
      }
      var loc = detailsShow.closest('.location');
      if (loc) {
        var allStoreInfo = loc.querySelector('.all_store_info');
        if (allStoreInfo) allStoreInfo.classList.remove('hide');
      }
      return;
    }

    // Collapse store details
    var closeDetails = target.closest('.store_locations_content .locations .location .close_sore_info');
    if (closeDetails) {
      var allStoreInfoClose = closeDetails.closest('.all_store_info');
      if (allStoreInfoClose) allStoreInfoClose.classList.add('hide');
      var locationClose = closeDetails.closest('.location');
      if (locationClose) {
        var allDetailsBtn = locationClose.querySelector('.store_info .store-details.all_details');
        if (allDetailsBtn) allDetailsBtn.classList.remove('show');
        var detailBtn = locationClose.querySelector('.store_info .store-details.detail');
        if (detailBtn) detailBtn.classList.add('show');
      }
    }
  }

  function init() {
    if (!document.querySelector('.store_locations_content')) return;
    // Do not create .store-locator-overlay until open — avoids dark veil FOUC while cms CSS is async
    bindCloseButtons();
    document.addEventListener('click', onDocumentClick);
    // Re-bind close after desktop HTML move in shopify.min.js
    document.addEventListener('DOMContentLoaded', bindCloseButtons);
    window.addEventListener('load', bindCloseButtons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose helpers for re-bind after DOM moves
  window.Curacao = window.Curacao || {};
  window.Curacao.StoreLocator = {
    open: openPanel,
    close: closePanel,
    bindCloseButtons: bindCloseButtons
  };
})();
